export const impactionPointsDialogMapper = (pointOrder, impactionPoint) => ({
  checkPares: pointOrder.checkPares,
  id: impactionPoint.id,
  name: impactionPoint.name,
  pointOrderId: pointOrder.id,
  parId: pointOrder.par.id,
  order: pointOrder.order,
});
